import { defineComponent as S, inject as N, ref as T, computed as f, watchEffect as j, h as n } from "vue";
import q from "./ghl-ui.es1384.js";
import { uploadInjectionKey as F } from "./ghl-ui.es1150.js";
import { imageIcon as M, documentIcon as A } from "./ghl-ui.es1385.js";
import { isImageFile as L } from "./ghl-ui.es1151.js";
import E from "./ghl-ui.es706.js";
import c from "./ghl-ui.es862.js";
import z from "./ghl-ui.es446.js";
import K from "./ghl-ui.es1386.js";
import g from "./ghl-ui.es253.js";
import G from "./ghl-ui.es1032.js";
import H from "./ghl-ui.es905.js";
import J from "./ghl-ui.es1387.js";
import Q from "./ghl-ui.es1388.js";
import V from "./ghl-ui.es1389.js";
import W from "./ghl-ui.es1390.js";
import { warn as X } from "./ghl-ui.es853.js";
import { download as Y } from "./ghl-ui.es963.js";
var Z = globalThis && globalThis.__awaiter || function(e, i, o, r) {
  function d(s) {
    return s instanceof o ? s : new o(function(u) {
      u(s);
    });
  }
  return new (o || (o = Promise))(function(s, u) {
    function w(a) {
      try {
        h(r.next(a));
      } catch (v) {
        u(v);
      }
    }
    function p(a) {
      try {
        h(r.throw(a));
      } catch (v) {
        u(v);
      }
    }
    function h(a) {
      a.done ? s(a.value) : d(a.value).then(w, p);
    }
    h((r = r.apply(e, i || [])).next());
  });
};
const y = {
  paddingMedium: "0 3px",
  heightMedium: "24px",
  iconSizeMedium: "18px"
}, ge = S({
  name: "UploadFile",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    file: {
      type: Object,
      required: !0
    },
    listType: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const i = N(F), o = T(null), r = T(""), d = f(() => {
      const {
        file: t
      } = e;
      return t.status === "finished" ? "success" : t.status === "error" ? "error" : "info";
    }), s = f(() => {
      const {
        file: t
      } = e;
      if (t.status === "error")
        return "error";
    }), u = f(() => {
      const {
        file: t
      } = e;
      return t.status === "uploading";
    }), w = f(() => {
      if (!i.showCancelButtonRef.value)
        return !1;
      const {
        file: t
      } = e;
      return ["uploading", "pending", "error"].includes(t.status);
    }), p = f(() => {
      if (!i.showRemoveButtonRef.value)
        return !1;
      const {
        file: t
      } = e;
      return ["finished"].includes(t.status);
    }), h = f(() => {
      if (!i.showDownloadButtonRef.value)
        return !1;
      const {
        file: t
      } = e;
      return ["finished"].includes(t.status);
    }), a = f(() => {
      if (!i.showRetryButtonRef.value)
        return !1;
      const {
        file: t
      } = e;
      return ["error"].includes(t.status);
    }), v = E(() => r.value || e.file.thumbnailUrl || e.file.url), B = f(() => {
      if (!i.showPreviewButtonRef.value)
        return !1;
      const {
        file: {
          status: t
        },
        listType: l
      } = e;
      return ["finished"].includes(t) && v.value && l === "image-card";
    });
    function C() {
      i.submit(e.file.id);
    }
    function k(t) {
      t.preventDefault();
      const {
        file: l
      } = e;
      ["finished", "pending", "error"].includes(l.status) ? b(l) : ["uploading"].includes(l.status) ? U(l) : X("upload", "The button clicked type is unknown.");
    }
    function P(t) {
      t.preventDefault(), O(e.file);
    }
    function b(t) {
      const {
        xhrMap: l,
        doChange: m,
        onRemoveRef: {
          value: R
        },
        mergedFileListRef: {
          value: _
        }
      } = i;
      Promise.resolve(R ? R({
        file: Object.assign({}, t),
        fileList: _
      }) : !0).then(($) => {
        if ($ === !1)
          return;
        const D = Object.assign({}, t, {
          status: "removed"
        });
        l.delete(t.id), m(D, void 0, {
          remove: !0
        });
      });
    }
    function O(t) {
      const {
        onDownloadRef: {
          value: l
        }
      } = i;
      Promise.resolve(l ? l(Object.assign({}, t)) : !0).then((m) => {
        m !== !1 && Y(t.url, t.name);
      });
    }
    function U(t) {
      const {
        xhrMap: l
      } = i, m = l.get(t.id);
      m == null || m.abort(), b(Object.assign({}, t));
    }
    function x() {
      const {
        onPreviewRef: {
          value: t
        }
      } = i;
      if (t)
        t(e.file);
      else if (e.listType === "image-card") {
        const {
          value: l
        } = o;
        if (!l)
          return;
        l.click();
      }
    }
    const I = () => Z(this, void 0, void 0, function* () {
      const {
        listType: t
      } = e;
      t !== "image" && t !== "image-card" || i.shouldUseThumbnailUrlRef.value(e.file) && (r.value = yield i.getFileThumbnailUrlResolver(e.file));
    });
    return j(() => {
      I();
    }), {
      mergedTheme: i.mergedThemeRef,
      progressStatus: d,
      buttonType: s,
      showProgress: u,
      disabled: i.mergedDisabledRef,
      showCancelButton: w,
      showRemoveButton: p,
      showDownloadButton: h,
      showRetryButton: a,
      showPreviewButton: B,
      mergedThumbnailUrl: v,
      shouldUseThumbnailUrl: i.shouldUseThumbnailUrlRef,
      renderIcon: i.renderIconRef,
      imageRef: o,
      handleRemoveOrCancelClick: k,
      handleDownloadClick: P,
      handleRetryClick: C,
      handlePreviewClick: x
    };
  },
  render() {
    const {
      clsPrefix: e,
      mergedTheme: i,
      listType: o,
      file: r,
      renderIcon: d
    } = this;
    let s;
    const u = o === "image";
    u || o === "image-card" ? s = !this.shouldUseThumbnailUrl(r) || !this.mergedThumbnailUrl ? n("span", {
      class: `${e}-upload-file-info__thumbnail`
    }, d ? d(r) : L(r) ? n(c, {
      clsPrefix: e
    }, {
      default: () => M
    }) : n(c, {
      clsPrefix: e
    }, {
      default: () => A
    })) : n("a", {
      rel: "noopener noreferer",
      target: "_blank",
      href: r.url || void 0,
      class: `${e}-upload-file-info__thumbnail`,
      onClick: this.handlePreviewClick
    }, o === "image-card" ? n(z, {
      src: this.mergedThumbnailUrl || void 0,
      previewSrc: r.url || void 0,
      alt: r.name,
      ref: "imageRef"
    }) : n("img", {
      src: this.mergedThumbnailUrl || void 0,
      alt: r.name
    })) : s = n("span", {
      class: `${e}-upload-file-info__thumbnail`
    }, d ? d(r) : n(c, {
      clsPrefix: e
    }, {
      default: () => n(K, null)
    }));
    const p = n(q, {
      show: this.showProgress,
      percentage: r.percentage || 0,
      status: this.progressStatus
    }), h = o === "text" || o === "image";
    return n("div", {
      class: [`${e}-upload-file`, `${e}-upload-file--${this.progressStatus}-status`, r.url && r.status !== "error" && o !== "image-card" && `${e}-upload-file--with-url`, `${e}-upload-file--${o}-type`]
    }, n("div", {
      class: `${e}-upload-file-info`
    }, s, n("div", {
      class: `${e}-upload-file-info__name`
    }, h && (r.url && r.status !== "error" ? n("a", {
      rel: "noopener noreferer",
      target: "_blank",
      href: r.url || void 0,
      onClick: this.handlePreviewClick
    }, r.name) : n("span", {
      onClick: this.handlePreviewClick
    }, r.name)), u && p), n("div", {
      class: [`${e}-upload-file-info__action`, `${e}-upload-file-info__action--${o}-type`]
    }, this.showPreviewButton ? n(g, {
      key: "preview",
      quaternary: !0,
      type: this.buttonType,
      onClick: this.handlePreviewClick,
      theme: i.peers.Button,
      themeOverrides: i.peerOverrides.Button,
      builtinThemeOverrides: y
    }, {
      icon: () => n(c, {
        clsPrefix: e
      }, {
        default: () => n(G, null)
      })
    }) : null, (this.showRemoveButton || this.showCancelButton) && !this.disabled && n(g, {
      key: "cancelOrTrash",
      theme: i.peers.Button,
      themeOverrides: i.peerOverrides.Button,
      quaternary: !0,
      builtinThemeOverrides: y,
      type: this.buttonType,
      onClick: this.handleRemoveOrCancelClick
    }, {
      icon: () => n(H, null, {
        default: () => this.showRemoveButton ? n(c, {
          clsPrefix: e,
          key: "trash"
        }, {
          default: () => n(J, null)
        }) : n(c, {
          clsPrefix: e,
          key: "cancel"
        }, {
          default: () => n(Q, null)
        })
      })
    }), this.showRetryButton && !this.disabled && n(g, {
      key: "retry",
      quaternary: !0,
      type: this.buttonType,
      onClick: this.handleRetryClick,
      theme: i.peers.Button,
      themeOverrides: i.peerOverrides.Button,
      builtinThemeOverrides: y
    }, {
      icon: () => n(c, {
        clsPrefix: e
      }, {
        default: () => n(V, null)
      })
    }), this.showDownloadButton ? n(g, {
      key: "download",
      quaternary: !0,
      type: this.buttonType,
      onClick: this.handleDownloadClick,
      theme: i.peers.Button,
      themeOverrides: i.peerOverrides.Button,
      builtinThemeOverrides: y
    }, {
      icon: () => n(c, {
        clsPrefix: e
      }, {
        default: () => n(W, null)
      })
    }) : null)), !u && p);
  }
});
export {
  ge as default
};
